import { render, staticRenderFns } from "./formAdminFormat.vue?vue&type=template&id=2d2adcb7"
import script from "./formAdminFormat.vue?vue&type=script&lang=js"
export * from "./formAdminFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports